import { RootState } from "store";

export const selectShowAssignedTableNudge = (state: RootState) =>
  state.assignedTableNudge.isVisible;
